import { createFeatureSelector, createSelector } from "@ngrx/store";

import * as fromStory from "../reducers/story.reducer";

export const selectStoryState =
    createFeatureSelector<fromStory.StoryState>("story");

export const selectStory = createSelector(
    selectStoryState,
    (storyState) => storyState.story,
);

export const selectStoryLoading = createSelector(
    selectStoryState,
    (storyState) => storyState.loading,
);

export const selectStoryParagraphs = createSelector(
    selectStory,
    (story) => story?.storyContent.paragraphList,
);

export const selectStoryimmersiveContentColor = createSelector(
    selectStory,
    (story) => story?.storyContent.immersiveContentColor,
);
